var DataTables = function () { // eslint-disable-line no-unused-vars
    'use strict';

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */

    function buildButton(name, href, innerHtml) {
        return "<a class='btn btn-default' data-toggle='tooltip' title='"
            + name
            + "' href='"
            + href
            + "'>" + innerHtml
            + "</a>";
    };

    function buildDropButton(name, href, innerHtml) {
        return "<a class='dropdown-item' data-toggle='tooltip' data-boundary='window' title='"
            + name
            + "' href='"
            + href
            + "'>" + innerHtml
            + "</a>";
    };


    function buildEditButton(href, condition) {
        condition = condition == null ? true : condition;
        return condition ? buildButton("Edit", href, "<i class='fas fa-lg fa-edit'></i>") : "";
    }

    function buildViewButton(href, condition) {
        condition = condition == null ? true : condition;
        return condition ? buildButton("View", href, "<i class='fas fa-lg fas fa-binoculars'></i>") : "";
    }

    function buildDeleteButton(callback, passThrough, condition) {
        condition = condition == null ? true : condition;
        return condition
            ? " <a class='btn btn-default fd-datatable-delete' data-fd-control='confirmationpopover' data-fd-passthrough='" +
            passThrough +
            "' data-fd-confirmcallback='" +
            + callback +
            "'>" +
            "<i class='fa fa-lg fa-trash'></i></a>"
            : "";
    }

    function buildTrendsButton(href, condition) {
        condition = condition == null ? true : condition;
        return condition ? buildButton("Trends", href, "<i class='fas fa-lg fa-chart-bar'></i>") : "";
    }


    function buildKpisButton(href, condition) {
        condition = condition == null ? true : condition;
        return condition ? buildButton("Kpis", href, "<i class='fa fa-lg fas fa-key'></i>") : "";
    }

    function renderInnerButtons(buttons) {
        let renderedButtons = "";
        buttons.forEach(function (button) {
            button.condition = button.condition == null ? true : button.condition;
            if (button.condition) {
                renderedButtons += buildButton(button.name, button.href, button.innerHtml);
            }
        });

        return renderedButtons;
    }

    function renderDropButtons(buttons) {
        let renderedButtons = "<a class='btn fd-margin-left-5 dropdown-toggle' data-boundary='window' data-toggle='dropdown' aria-expanded='false' href='#' role='button' aria-haspopup='true' aria-expanded='false'><i class='fa fa-lg fas fa-ellipsis-h'></i></a><div class='dropdown-menu'>";

        buttons.forEach(function (button) {
            const condition = button.condition == null ? true : button.condition;
            renderedButtons += condition ? buildDropButton(button.name, button.href, button.innerHtml) : "";
        });

        renderedButtons += "</div>";
        return renderedButtons;
    }

    function buildKnownButtons({ trend, kpis, view, edit, others }, dropButtons) {
        const buttons = "<div class='btn btn-group'>" +
            (trend ? buildTrendsButton(trend.href, trend.condition) : "") +
            (kpis ? buildKpisButton(kpis.href, kpis.condition) : "") +
            (view ? buildViewButton(view.href, view.condition) : "") +
            (edit ? buildEditButton(edit.href, edit.condition) : "") +
            (others ? renderInnerButtons(others) : "") +
            (dropButtons ? renderDropButtons(dropButtons) : "") +
            "</div>";
        return buttons;
    };



    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */


    return {
        buildKnownButtons: buildKnownButtons,
        buildButton: buildButton,
        buildTrendButton: buildTrendsButton,
        buildKpisButton: buildKpisButton,
        buildViewButton: buildViewButton,
        buildEditButton: buildEditButton,
        resizeDataTable: function () {
            $('.dataTable').each(function (index, element) {
                $(element).DataTable().responsive.recalc();
            });
        }
    };
}();